import CloseIcon from '@mui/icons-material/Close';
import { Alert, Button, IconButton, Snackbar } from '@mui/material';
import { useTranslation } from 'react-i18next';
import useVersionCheck from '../hooks/useVersionCheck';

export default function VersionUpdateNotification() {
    const { t } = useTranslation();
    const { isNewVersionAvailable, dismissUpdate, refreshPage } = useVersionCheck();

    return (
        <Snackbar
            open={isNewVersionAvailable}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            onClose={dismissUpdate}
        >
            <Alert
                severity="info"
                variant="filled"
                action={
                    <>
                        <Button color="inherit" size="small" onClick={refreshPage}>
                            <span>{t('action.refreshPage')}</span>
                        </Button>
                        <IconButton color="inherit" size="small" aria-label={t('action.close')} onClick={dismissUpdate}>
                            <CloseIcon fontSize="small" />
                        </IconButton>
                    </>
                }
            >
                <span>{t('notification.newVersion')}</span>
            </Alert>
        </Snackbar>
    );
}
